type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

const AUTH_SKIP_RULES: {
  path: string;
  methods?: HttpMethod[]; // undefined = all methods
}[] = [
  {
      path: '/session',
      methods: ['POST'],
  },
  {
    path: '/session/update-password',
    methods: ['POST']
  }
];

export function shouldSkip(url: string, method: string): boolean {
  // ✅ Always skip auth for S3 presigned URLs
  if (url.startsWith('https://') && url.includes('.s3.amazonaws.com')) {
    return true;
  }

  return AUTH_SKIP_RULES.some(rule => {
    const pathMatches = url.includes(rule.path);
    const methodMatches =
      !rule.methods || rule.methods.includes(method.toUpperCase() as HttpMethod);

    return pathMatches && methodMatches;
  });
}
